const PartnerClubSegments = {
  Iconic: "Iconic",
  Elite: "Elite",
  Achiever: "Learner A",
  Amateur: "Learner A",
  Cleanup: "Learner B",
  Starter: "Starter",
};
export default PartnerClubSegments;
